import { CardTypes, IPaymentDetails, IPaymentMethod } from 'features/payment/types';
import { isCreditCardNotExpired, splitExpiry } from 'features/payment/utils';
import { Platform } from 'react-native';

import { CurrentSelectedMethodType } from 'components/payment-method/types';

import { ICheckNativePaymentDefaulting, INativePaymentDefaulted } from '../../types';

export interface WalletOrder {
  first: CardTypes;
  second: CardTypes;
}

/**
 * Returns the platform-preferred wallet order.
 * iOS favors Apple Pay, Android favors Google Pay, web defaults to Apple Pay.
 */
export const getPreferredWalletOrder = (): WalletOrder => {
  if (Platform.OS === 'android') {
    return { first: CardTypes.GOOGLE_PAY, second: CardTypes.APPLE_PAY };
  }
  return { first: CardTypes.APPLE_PAY, second: CardTypes.GOOGLE_PAY };
};

export const checkNativePayDefaulting = ({
  paymentMethodId,
  cardType,
  canUseNativePayment = false,
}: ICheckNativePaymentDefaulting): boolean => paymentMethodId === cardType && canUseNativePayment;

export const isNativePaymentDefaulted = ({
  paymentMethodId,
  canUseApplePay = false,
  canUseGooglePay = false,
}: INativePaymentDefaulted): boolean => {
  if (
    checkNativePayDefaulting({
      paymentMethodId,
      cardType: CardTypes.APPLE_PAY,
      canUseNativePayment: canUseApplePay,
    }) ||
    checkNativePayDefaulting({
      paymentMethodId,
      cardType: CardTypes.GOOGLE_PAY,
      canUseNativePayment: canUseGooglePay,
    })
  ) {
    return true;
  }

  return false;
};

export const transformPaymentDetailsToPaymentMethod = (
  paymentDetails?: IPaymentDetails
): IPaymentMethod | undefined => {
  if (!paymentDetails?.state) {
    return undefined;
  }

  const { expiryMonth, expiryYear } = splitExpiry(paymentDetails.state.expiry ?? '');

  return {
    accountIdentifier: CurrentSelectedMethodType.ADD_NEW_CARD,
    fdAccountId: CurrentSelectedMethodType.ADD_NEW_CARD,
    orbitalIdentifier: CurrentSelectedMethodType.ADD_NEW_CARD,
    credit: {
      alias: paymentDetails?.state?.cardNumber.slice(-4) || '',
      cardType: paymentDetails?.state?.cardType || '',
      expiryMonth,
      expiryYear,
      panToken: '',
    },
    selected: true,
    prepaid: null,
    cash: false,
    cashapp: false,
    paypal: false,
    venmo: false,
  };
};

export const filterExpiredCreditCards = (methods: IPaymentMethod[]): IPaymentMethod[] => {
  return methods.filter(
    method => !method.credit?.expiryYear || isCreditCardNotExpired(method.credit)
  );
};
